export default {
  title: 'Openingstijden & locatie',
  set_different_opening_hours: 'Andere openingstijden voor bezorging instellen',
  delivery_opening_hours: 'Openingstijden bezorging',
  sections: {
    general: 'Algemene openingstijden',
    holidays: 'Bestellingen pauzeren (feestdagen)',
    create_time: 'Openingstijd toevoegen',
    edit_time: 'Tijd bewerken',
    delivery_schedule: 'Openingstijden bezorging',
  },
  tabs: {
    open_times: 'Openingstijden',
    location: 'Locatie',
  },
  form: {
    select_all: {
      label: 'Alle dagen selecteren',
    },
    holiday_starts_at: {
      label: 'Startdatum',
    },
    holiday_ends_at: {
      label: 'Einddatum',
    },
    has_delivery_schedule: {
      label: 'Andere openingstijden voor bezorging instellen',
    },
    has_multiple_locations: {
      label: 'Verschillende locaties voor de week instellen',
    },
  },
  labels: {
    day_location: '{{day}} locatie {{index}}',
    selected_days: 'Geselecteerde dagen',
    orders_paused: 'Bestellingen gepauzeerd',
    open_time: 'Openingstijd',
    close_time: 'Sluitingstijd',
  },
  errors: {
    close_time: 'De sluitingstijd kan niet 00:00 zijn. Voer 23:59 in',
  },
  buttons: {
    edit: 'Bewerken',
    add_schedule_unit: 'Openingstijd toevoegen',
    add_holiday: 'Feestdag toevoegen',
    delete: 'Verwijderen',
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  toasts: {
    changes_got_saved: 'Informatie succesvol bijgewerkt',
    failed_to_save_changes: 'Opslaan van wijzigingen mislukt',
  },
};
